import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class FormTextMixin extends Vue {
   localValue: any = ""

   created() {
     this.localValue = this.value
   }

    @Watch('localValue')
    localValueChanged (newVal) {
      this.$emit('input', newVal)
    }

    @Watch('value')
    valueChanged (newVal) {
      this.localValue = newVal;
    }

    @Prop({ default: null })
    value: [string, number, boolean]

    @Prop({ default: null})
    shoeClear: boolean
    
    reset () {
      this.localValue = null
    }
  
}
